import { darkGray700, white } from '@modusign/design-system/colors';

export const background = white;
export const text = darkGray700;

export const textPrimaryDark = '#FF9900';

export const participantOrder1 = '#ffcf00';
export const participantOrder2 = '#51c8aa';
export const participantOrder3 = '#5991f4';
export const participantOrder4 = '#ff5252';
export const participantOrder5 = '#9b8aff';
export const participantOrder6 = '#c4f02c';
export const participantOrder7 = '#e892f7';
export const participantOrder8 = '#ff8515';
export const participantOrder9 = '#4fdfff';
export const participantOrder10 = '#ff52c5';

export const brandNaver = '#00c73c';
export const brandGoogle = '#4285f4';
export const brandFacebook = '#4267b2';

export const bodyNeutralDark = '#f8f8f8';
export const bodyLegacy = '#f1f1f1';
